import {
    APPEARANCE_CHOICE_DARK,
    APPEARANCE_CHOICE_HIGH_CONTRAST,
    APPEARANCE_CHOICE_LIGHT,
    SCHEME_DARK,
    SCHEME_DARK_HIGH_CONTRAST,
    SCHEME_LIGHT,
    SCHEME_LIGHT_HIGH_CONTRAST,
    normalizeAppearanceChoice,
} from './appearanceSchemes';

export const PREFERS_DARK_QUERY = '(prefers-color-scheme: dark)';
export const PREFERS_MORE_CONTRAST_QUERY = '(prefers-contrast: more)';
export const FORCED_COLORS_QUERY = '(forced-colors: active)';

export const DEVICE_PREFERENCE_QUERIES = [
    PREFERS_DARK_QUERY,
    PREFERS_MORE_CONTRAST_QUERY,
    FORCED_COLORS_QUERY,
];

export function readDevicePreferences(matchMedia) {
    const matches = query => matchMedia !== null && Boolean(matchMedia(query).matches);

    return {
        prefersDark: matches(PREFERS_DARK_QUERY),
        prefersMoreContrast: matches(PREFERS_MORE_CONTRAST_QUERY) || matches(FORCED_COLORS_QUERY),
    };
}

export default function resolveAppearanceScheme(choice, { prefersDark, prefersMoreContrast }) {
    const normalizedChoice = normalizeAppearanceChoice(choice);

    if (normalizedChoice === APPEARANCE_CHOICE_LIGHT) {
        return SCHEME_LIGHT;
    }

    if (normalizedChoice === APPEARANCE_CHOICE_DARK) {
        return SCHEME_DARK;
    }

    if (normalizedChoice === APPEARANCE_CHOICE_HIGH_CONTRAST || prefersMoreContrast) {
        return prefersDark ? SCHEME_DARK_HIGH_CONTRAST : SCHEME_LIGHT_HIGH_CONTRAST;
    }

    return prefersDark ? SCHEME_DARK : SCHEME_LIGHT;
}
